import React from 'react';
import { NavLink } from 'react-router-dom';
import axiosClient from '../../services/axiosClient';
import apiConfig from '../../services/apiconfig';

const defaultIcons = [
    require('./../../images/icon/crane-1.png'),
    require('./../../images/icon/renovation.png'),
    require('./../../images/icon/toolbox.png'),
    require('./../../images/icon/compass.png'),
];

var img1 = require('./../../images/background/bg-6.png');

class OurServices extends React.Component {
    state = {
        services: [],
        loading: true
    };

    componentDidMount() {
        axiosClient.get(apiConfig.SERVICES.GET_ALL)
            .then(res => {
                const apiServices = res.data.data || [];
                if (apiServices.length > 0) {
                    this.setState({ services: apiServices, loading: false });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(err => {
                console.error("Error fetching services for home", err);
                this.setState({ loading: false });
            });

        function loadScript(src) {
            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            });
        }

        loadScript('./assets/js/masonary.js');
    }

    render() {
        const { services, loading } = this.state;
        const limit = this.props.limit || 4;
        const displayServices = (services || []).slice(0, limit);

        return (
            <>
                <div className="section-full mobile-page-padding p-b50 square_shape2">
                    <div className="section-content">
                        <div className="Service-half-top p-t80 bg-dark bg-moving" style={{ backgroundImage: 'url(' + img1 + ')' }}>
                            <div className="container">
                                {/* TITLE START */}
                                <div className="section-head text-white">
                                    <div className="mt-separator-outer separator-left">
                                        <div className="mt-separator">
                                            <h2 className="text-white text-uppercase sep-line-one ">
                                                <span className="font-weight-300 text-primary">Our</span> Services
                                            </h2>
                                        </div>
                                    </div>
                                    <h3>
                                        We provide a wide range of services. From electro-mechanical to water systems, we have the expertise to deliver.
                                    </h3>
                                </div>
                                {/* TITLE END */}
                            </div>
                        </div>
                        <div className="services-half-bottom">
                            <div className="container">
                                {loading ? (
                                    <div className="text-center p-a50 text-white">Loading services...</div>
                                ) : (
                                    <>
                                        <div className="row">
                                            {displayServices.map((item, index) => {
                                                const icon = item.image || defaultIcons[index % defaultIcons.length];
                                                const desc = item.short_description || item.description || '';
                                                return (
                                                    <div className="col-md-3 col-sm-6" key={item.id || index}>
                                                        <div className="mt-icon-box-wraper m-b30">
                                                            <div className="relative icon-count-2 bg-gray p-a30 p-tb50" style={{ minHeight: '340px' }}>
                                                                <span className="icon-count-number">{index + 1}</span>
                                                                <div className="icon-md inline-icon m-b15 text-primary scale-in-center">
                                                                    <span className="icon-cell">
                                                                        <img
                                                                            src={icon}
                                                                            alt={item.name}
                                                                            style={{ width: '48px', height: '48px', objectFit: 'contain' }}
                                                                        />
                                                                    </span>
                                                                </div>
                                                                <div className="icon-content">
                                                                    <h4 className="mt-tilte m-b25">{item.name}</h4>
                                                                    <p>{desc.length > 120 ? desc.substring(0, 120) + '...' : desc}</p>
                                                                    <NavLink
                                                                        to="/services"
                                                                        className="site-button-link"
                                                                        data-hover="Read More"
                                                                    >
                                                                        Read More <i className="fa fa-angle-right arrow-animation" />
                                                                    </NavLink>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                        {services.length > limit && (
                                            <div className="text-center p-t20">
                                                <NavLink to="/services" className="site-button btn-effect">
                                                    View All Services <i className="fa fa-angle-right m-l10" />
                                                </NavLink>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="hilite-title text-left p-l50 text-uppercase text-pop-up-top">
                        <strong>Services</strong>
                    </div>
                </div>
            </>
        );
    }
}

export default OurServices;
